import locale from "csi/locale";
import csi from "csi/main";
import Widget from "csi/table/Widget";
import { QueryLevel } from "csi/view/_query/Level";
import xml from "csi/xml";
import Query from "csi/xml/Query";
import declare from "dojo/_base/declare";

const AggregateFromRecipeBaseProductTableMixin = declare(Widget, {

	/**
	 * Modifies query depending on if action is called from BOM section and selected type
	 * @param subtypeFieldName 
	 * @param subtypeAttrName 
	 * @param ql 
	 */
	modifyQuery(subtypeFieldName: string, subtypeAttrName: string, ql: QueryLevel): void {
		// Get URL of BOM Section, save it in case 'Save and New' is selected
		const controller = this.getSourceController();
		if (!controller) {
			return;
		}

		// Previous Wizard page FormData is stored in Context
		const ctx = this.getContext();
		const baseProductTypeField = ctx.defView.m_formData.getField(locale.resource(subtypeFieldName));
		const isBaseProductTypeSelected = baseProductTypeField.getValue() !== csi.EMPTY_URL;
		
		// Build Query for Aggregate BaseProduct table
		const query = new Query();
		query.Attr("Active", xml.OP_EQUALS, true);

		// If a BaseProduct Type is selected, query for BaseProducts of that type
		if (isBaseProductTypeSelected) {
			query.RefAttr(subtypeAttrName, xml.OP_EQUALS, baseProductTypeField.getValue());
		}
		
		ql.serverQuery = query;
	},

	/**
	 * Adds to query filter to remove Parent FormulatedProduct of Recipe
	 * @param ql 
	 */
	modifyQueryRemoveParentProduct(ql: QueryLevel): void {
		// Get parent FormulatedProduct
		const ctx = this.getContext();
		const revNode = ctx.getContextNode();
		const recipeNode = ctx.cache.getNode(revNode.__Parent__);
		const formulatedProductURL = recipeNode.__Parent__;

		// Add filter to omit parent
		const query = ql.serverQuery;
		if (query){
			query.Not().Node(xml.PROP_URL, xml.OP_EQUALS, formulatedProductURL);
		}
	},
});

export = AggregateFromRecipeBaseProductTableMixin;